var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7418 1.85684L4.58346 3.4235C3.62513 3.78184 2.8418 4.91517 2.8418 5.93184V12.1235C2.8418 13.1068 3.4918 14.3985 4.28346 14.9902L7.8668 17.6652C9.0418 18.5485 10.9751 18.5485 12.1501 17.6652L15.7335 14.9902C16.5251 14.3985 17.1751 13.1068 17.1751 12.1235V5.93184C17.1751 4.90684 16.3918 3.7735 15.4335 3.41517L11.2751 1.85684C10.5668 1.5985 9.43346 1.5985 8.7418 1.85684Z",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 10.4154C10.9201 10.4154 11.6663 9.66917 11.6663 8.7487C11.6663 7.82822 10.9201 7.08203 9.99967 7.08203C9.0792 7.08203 8.33301 7.82822 8.33301 8.7487C8.33301 9.66917 9.0792 10.4154 9.99967 10.4154Z",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.416V12.916",
    stroke: "#535353",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldSecurity);
export default __webpack_public_path__ + "static/media/shield-security.49f50294c89bfe63d4b32e73a2f5f991.svg";
export { ForwardRef as ReactComponent };